import requests from "./httpService";

const OnewayPickupBasicRateServices = {
  getAllOnewayPickupBasicRate: async (body) => {
    return requests.get(`/onewaypickup/get`);
  },

  addOnewayPickupBasicRate: async (body) => {
    return requests.post(`/onewaypickup/add`, body);
  },
  getOnewayPickupBasicRateById: async (id) => {

    return requests.get(`/onewaypickup/get/${id}`);
  },

  updateOnewayPickupBasicRate: async (id, body) => {
    return requests.put(`/onewaypickup/update/${id}`, body);
  },

  deleteOnewayPickupBasicRate: async (id) => {
    return requests.delete(`/onewaypickup/delete/${id}`);
  },

  updateOnewayPickupStatus: async (id, body) => {
    return requests.put(`/onewaypickup/update-status/${id}`, body);
  },
  listOnewayOptions:async()=>{
    return requests.get(`/onewaypickup/listonewayoption`)
  }
};

export default OnewayPickupBasicRateServices;
